module.exports = __webpack_public_path__ + "doodle.svg?691a00d5cb4c40457364b6d020631249";